import { render } from "./ManageTlAsesment.vue?vue&type=template&id=23907116&scoped=true"
import script from "./ManageTlAsesment?vue&type=script&lang=js"
export * from "./ManageTlAsesment?vue&type=script&lang=js"

import "./ManageTlAsesment.vue?vue&type=style&index=0&id=23907116&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23907116"]])

export default __exports__